module.exports = __webpack_public_path__ + "resources/message-sent-bf5ee0ccad51e80a9c3032e5d79191da.svg";